const Upercase = {
    created() { },
    beforeMount(el, binding, vnode) {
        const elToUpper = () => {
            el.value = el.value.toUpperCase();
        };
        el.onchange = elToUpper;
        el.onkeyup = elToUpper;
    },
    mounted() { },
    beforeUpdate() { },
    updated() { },
    beforeUnmount(el) {
    },
    unmounted() { }
};
export default Upercase;
